import { Grid } from "@material-ui/core";
import { Button } from "@worthy-npm/worthy-ui-components";
import { confirmShipBackAddress } from "actions/item";
import { rootUrl } from "helpers/ApplicationHelper";
import UserActions from "lib/userActions";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpPopup from "components/popups/otpPopup";
import WorthyApi from "lib/api/worthyApi";

import {
    getFlowSteps,
    getFormattedAddress,
    getShipBackText,
    getStep,
    gridClasses,
    getSignedDocUrl,
    getItemsDescriptions,
} from "./helpers";

const ShipBackShipment = (props) => {
    const dispatch = useDispatch();
    const ado = useSelector((state) => state.ADO);
    const [isLoading, setIsLoading] = useState(false);
    const {
        item,
        item: {
            shipback_info: {
                items,
                address,
                bundle_workflow_state,
                shipping_center_address,
                isSellerAddressChanged,
                hasError,
                shipping_option,
                document_id,
            },
        },
    } = props;
    const {
        user: { first_name: firstname, last_name: lastname, id: seller_id },
    } = ado;
    const step = getStep(bundle_workflow_state);
    const isReleaseFormSigned = !!document_id;
    const isDirect = shipping_option === "direct";
    const flowSteps = getFlowSteps(
        bundle_workflow_state,
        shipping_option,
        isReleaseFormSigned
    );
    const sellerAddress = getFormattedAddress(address);
    const shippingAddress = getFormattedAddress(shipping_center_address);

    const onConfirmClick = async (otpParams) => {
        setIsLoading(true);

        const action = await dispatch(
            confirmShipBackAddress(item.id, {
                shipping_center_address,
                seller_address: address,
                address_updated: isSellerAddressChanged,
                shipping_option,
                // document_id,
                ...otpParams,
            })
        );

        const event = "Shipback - Address on record updated";
        UserActions.myAccount(event, item.id, "Item");
        setIsLoading(false);

        return action;
    };

    const onDocumentSign = async () => {
        setIsLoading(true);
        try {
            const { data } = await WorthyApi.getSigningLink({
                redirect_uri: window.location.href,
                firstname,
                lastname,
                contents: getItemsDescriptions(items),
                item_id: item.id,
                seller_id,
                return_address: sellerAddress,
            });

            window.location.href = data.url;
        } catch (error) {
            // we check if it's local and server not running
            // just mock the behavior that should happen after signing
            if (__ENV__ === "development" && error._errorCodesList[0] === 404) {
                window.location.href = getSignedDocUrl();
                return;
            }
            // do something with error?
        } finally {
            setIsLoading(false);
        }
    };

    const onOtpVerify = async (params) => {
        const action = await onConfirmClick(params);

        return action.payload;
    };

    const startOtpFlow = () => {
        OtpPopup.initPopup({
            onVerify: onOtpVerify,
            userActionId: item.id,
        });
    };

    const onCTAClick = () => {
        if (isDirect && !isReleaseFormSigned) {
            onDocumentSign();
            return;
        }
        if (isDirect && isSellerAddressChanged) {
            startOtpFlow();
            return;
        }
        onConfirmClick();
    };

    const onSupportClick = () => {
        if ("Intercom" in window && Intercom.booted) {
            Intercom("show");
            return;
        }
        window.open(rootUrl('/about/contact'), "_blank");
    };

    useEffect(() => {
        if ("Intercom" in window && Intercom.booted) {
            return;
        }
        try {
            const event = JSON.parse(ado.intercomDataEvent);
            // Intercom script is added by the GTM module and it can be triggered pushing GTM event
        } catch (error) {}
    }, [ado]);

    return (
        <div className="shipBack--card shipBack--card-secondary">
            <Grid container classes={gridClasses}>
                <Grid item xs={12} classes={gridClasses}>
                    <h2 className="shipBack--subheader">
                        {step === 0
                            ? getShipBackText("shipmentDetails")
                            : getShipBackText("shipmentStatus")}
                    </h2>
                </Grid>

                {step === 0 && shipping_option !== "direct" && (
                    <Grid container style={{ margin: "8px 0 22px" }}>
                        <Grid item xs={6} classes={gridClasses}>
                            <div className="shipBack--text">
                                {getShipBackText("fedExShipment")}
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            style={{ textAlign: "right" }}
                            classes={gridClasses}
                        >
                            <div className="shipBack--text shipBack--text-light shipBack--text-line-through shipBack--text-inline">
                                $25
                            </div>
                            <div className="shipBack--text shipBack--text-light shipBack--text-inline">
                                &nbsp;-&nbsp;
                            </div>
                            <div className="shipBack--text shipBack--text-light shipBack--text-line-through shipBack--text-inline">
                                $65
                            </div>
                            &ensp;
                            <div className="shipBack--text shipBack--text-inline">
                                $0
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            style={{ marginTop: 5 }}
                            classes={gridClasses}
                        />
                        <Grid item xs={6} classes={gridClasses}>
                            <div className="shipBack--text">
                                {getShipBackText("insuranceIncluded")}
                            </div>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            style={{ textAlign: "right" }}
                            classes={gridClasses}
                        >
                            <div className="shipBack--text shipBack--text-light shipBack--text-line-through shipBack--text-inline">
                                $50
                            </div>
                            &ensp;
                            <div className="shipBack--text shipBack--text-inline">
                                $0
                            </div>
                        </Grid>
                    </Grid>
                )}
                {(step > 0 || shipping_option === "direct") && (
                    <div className="shipBack--steps-container">
                        {flowSteps.map((flowStep, index) => (
                            <div
                                key={index}
                                className={`shipBack--step${
                                    flowStep.active
                                        ? " shipBack--step-active"
                                        : ""
                                }${
                                    flowStep.completed
                                        ? " shipBack--step-completed"
                                        : ""
                                }`}
                            >
                                <div className="shipBack--step-indicator">
                                    <div className="shipBack--step-number">
                                        {index + 1}
                                    </div>
                                </div>
                                <div className="shipBack--text">
                                    {flowStep.text}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Grid>
            <Grid item xs={12} classes={gridClasses}>
                {step === 0 && (
                    <div className={"shipBack--shipment-button " + ((isLoading || !sellerAddress || (!isDirect && !shippingAddress) || hasError) ? 'disable' : '')}>
                        <Button
                            size="md"
                            onClick={onCTAClick}
                            isDisabled={
                                isLoading ||
                                !sellerAddress ||
                                (!isDirect && !shippingAddress) ||
                                hasError
                            }
                        >
                            {isDirect && !isReleaseFormSigned
                                ? getShipBackText("signCTA")
                                : getShipBackText("approveCTA")}
                        </Button>
                    </div>
                )}
                <div className="shipBack--shipment-button shipBack--support-btn-container">
                    <Button
                        variant="secondary"
                        size="md"
                        onClick={onSupportClick}
                    >
                        {getShipBackText("contactSupport")}
                    </Button>
                </div>
            </Grid>
        </div>
    );
};

export default ShipBackShipment;
